import styled from 'styled-components'
import FormControl from '@material-ui/core/FormControl'

const SetupSelectionWrapper = styled(FormControl)`
  width: 100%;
`

export default SetupSelectionWrapper
